import React from 'react';
import useFadeIn from './useFadeIn';
import './About.css';

const STATS = [
  { num: '2', label: 'Years Experience' },
  { num: '20+', label: 'Projects Shipped' },
  { num: '20+', label: 'Technologies' },
];

function About() {
  const ref = useFadeIn();

  return (
    <section id="about" className="section fade-in" ref={ref}>
      <p className="section-eyebrow">01 — About</p>
      <h2 className="section-heading">Who I Am</h2>
      <div className="section-divider" />

      <div className="about-grid">
        <div className="about-text">
          <p>
            I'm a <strong>Software Engineer</strong> who turns ideas into functional, scalable, and
            elegant digital solutions. I work with a diverse set of technologies with a strong passion
            for building seamless user experiences backed by robust, well-structured systems.
          </p>
          <br />
          <p>
            My core stack is <strong>React, Angular, Next.js</strong>, HTML, CSS, and JavaScript,
            with deep focus on performance and maintainability. I've also explored{' '}
            <strong>Web3 and blockchain-powered systems</strong>, bridging on-chain and off-chain
            workflows using innovative approaches.
          </p>
          <br />
          <p>
            I especially enjoy crafting smooth, high-performance, and user-friendly interfaces that
            feel alive and intuitive.
          </p>
        </div>

        <div className="about-stats">
          {STATS.map(({ num, label }) => (
            <div className="stat-card" key={label}>
              <div className="stat-num">{num}</div>
              <div className="stat-label">{label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default About;
